module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items) ? _c('div', {
    staticClass: "page5 animated fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h3', {
    staticClass: "title animated fadeIn"
  }, [_vm._v(_vm._s(_vm.items.page1.title))]), _vm._v(" "), _c('p', {
    staticClass: "animated fadeIn",
    domProps: {
      "innerHTML": _vm._s(_vm.items.page1.text)
    }
  })]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "media/page1/warehouse.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d73d8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page5.vue
// module id = 136
// module chunks = 0